import axios from 'axios';
import { ApiResponse, zps_ea_war } from '../zps';
import { MeansCash } from '../transactions';
import { handleDownload } from '../../app/utils/script';

// User Summary
export interface IUserSummary {
  entid: number;
  uid: number;
  name: string;
  lastOperationEid: number;
  lastOperation: string;
  lastOperationDt: string;
  lastOperationValue: number;
  cid: number;
  balance: number;
}

export interface IUserSummariesResponse extends ApiResponse {
  list: IUserSummary[];
  totalRows: number;
  type: string;
}

export interface IUserSummariesReportResponse extends ApiResponse {
  format: string;
  mime: string;
  name: string;
  report: string;
  type: string;
}

export interface IUserSummaryRequest {
  eid: number;
  entid: number;
  incOrSet: boolean;
  uid: number;
  value: number;
}

export const fetchUsersSummaries = (
  entid: number,
  offset: number,
  limit: number,
  totalRows: boolean,
  uid?: number,
  balance?: boolean
): Promise<IUserSummariesResponse> => {
  return axios
    .get<IUserSummariesResponse>(
      `${zps_ea_war}/tb401/transaction/user/?entid=${entid}&offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
        `${uid ? `&uid=${uid}` : ''}` +
        `${balance ? `&balance=${balance}` : ''}`
    )
    .then(res => res.data);
};

export const fetchUserSummaryDetails = (entid: number, uid: number, eid: number): Promise<IUserSummariesResponse> => {
  return axios
    .get<IUserSummariesResponse>(`${zps_ea_war}/tb401/transaction/user/?entid=${entid}&uid=${uid}&eid=${eid}`)
    .then(res => res.data);
};

export const updateUserSummary = (request: IUserSummaryRequest, controller: AbortController): Promise<ApiResponse> => {
  return axios
    .post<IUserSummariesResponse>(`${zps_ea_war}/tb401/transaction/user`, request, { signal: controller.signal })
    .then(res => res.data);
};

export const fetchUserSummaryXLSReport = (
  entid: number,
  controller: AbortController,
  balance?: boolean
): Promise<ApiResponse> => {
  return axios
    .get<IUserSummariesReportResponse>(
      `${zps_ea_war}/tb401/transaction/user/report?entid=${entid}&format=xls` +
        `${balance ? `&balance=${balance}` : ''}`,
      { signal: controller.signal }
    )
    .then(res => {
      handleDownload(res.data.report, res.data.name, res.data.mime);
      return res.data;
    });
};

// Withdraw Set
export interface IWithdrawSets {
  description: string;
  entid: number;
  gid: number;
  id: number;
  inUse: number;
  mc: MeansCash[];
}

export interface IWithdrawSetRequest {
  description: string;
  entid: number;
  id: number;
  mc: MeansCash[];
}

export interface IWithdrawSetsResponse extends ApiResponse {
  list: IWithdrawSets[];
  totalRows: number;
  type: string;
}

export const fetchWithdrawSets = (entid: number): Promise<IWithdrawSetsResponse> => {
  return axios.get<IWithdrawSetsResponse>(`${zps_ea_war}/withdrawalset/?entid=${entid}`).then(res => res.data);
};

export const fetchWithdrawSetDetails = (entid: number, id: number): Promise<IWithdrawSetsResponse> => {
  return axios.get<IWithdrawSetsResponse>(`${zps_ea_war}/withdrawalset/?entid=${entid}&id=${id}`).then(res => res.data);
};

export const addWithdrawSetDetails = (entid: number, id: number): Promise<ApiResponse> => {
  return axios.post<ApiResponse>(`${zps_ea_war}/withdrawalset/?entid=${entid}&id=${id}`).then(res => res.data);
};

export const updateWithdrawSetDetails = (
  request: IWithdrawSetRequest,
  controller: AbortController
): Promise<ApiResponse> => {
  return axios
    .put<IWithdrawSetsResponse>(`${zps_ea_war}/withdrawalset`, request, { signal: controller.signal })
    .then(res => res.data);
};

export const deleteWithdrawSetDetails = (entid: number, id: number): Promise<ApiResponse> => {
  return axios.delete<ApiResponse>(`${zps_ea_war}/withdrawalset/?entid=${entid}&id=${id}`).then(res => res.data);
};
